export const Name = 'handle-partial-view-analytics';
export const HandlePartialViewAnalytics = Name;
//# sourceMappingURL=index.js.map